import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import cls from 'classnames';
import styles from './MetricBar.less';
function MetricBar({ svg, className, ratio }) {
    return _jsx("img", { alt: "", className: cls(styles.metricBar, className), src: svg, style: { aspectRatio: `${ratio}` } });
}
export default memo(MetricBar);
